"use strict";

import {Component, Inject, Input, Output, OnInit, EventEmitter} from 'ng-metadata/core';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {SearchService} from '../search.service';
import {SearchFieldsService} from '../search.fields.service';
import {SearchBarService} from './searchBar.service';
import {getTabs} from '../../appConfig/appConfigForward';
import {getScopeList} from '../../appConfig/appConfigForward';
import {getSearchConfiguration, getBackendSystem, getAllowStartWithForCallNumber} from '../../appConfig/appConfigForward';
import {getVid} from '../../appConfig/appConfigForward';
import {getTabToTiles} from '../../appConfig/appConfigForward';
import {getQueryTerms} from '../../appConfig/appConfigForward';
import {getUIComponents} from '../../appConfig/appConfigForward';
import {isBrowserIE, isBrowserEdge} from '../../infra/browserSniffer'
import {getAttributesMap} from '../../appConfig/appConfigForward';
import {IAlertMsg} from '../../infra/widgets/alerts/alertMsg.interface';
import {AlertFactory, ALERT_MSG_TYPE} from '../../infra/widgets/alerts/alertFactory.service';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import {preventStateReload} from '../../infra/annotations';
import {SmoothScrollUtil} from '../../nddUtils/smoothScrollUtil.service';
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {JwtUtilService} from '../../security/jwtUtil.service';
import {MediaQueries} from "../../infra/mediaQueries.service";
import { AdvancedSearchService } from './advancedSearch.service';
import { MappingTablesCache } from '../../mappingTablesCache/mappingTablesCache.service';
import { BarcodeSearchService } from './barcodeSearch/barcodeSearch.service';

const uniq = require('lodash/uniq');
const isEmpty = require('lodash/isEmpty');
const flatten = require('lodash/flatten');
const get = require('lodash/get');

@Component({
    providers: [],
    'selector': 'prm-advanced-search',
    templateUrl: 'components/search/searchBar/advanced-search-header.html',
})


export class PrmAdvancedSearch implements OnInit {

    @Input() selectedScope: string;
    @Input() selectedTab: string;
    @Input() showTabAndScopes: boolean;
    @Input() typedQuery: string;
    @Input() switchedFromSimpleToAdvanced: boolean = false;
    @Input() advancedSearchCollapsed: boolean = false;
    @Output() updateFindInDbEvent = new EventEmitter();
    @Output() updateAdvancedSearchParams = new EventEmitter();

    private searchTabs = getTabs();
    private scopes = getScopeList();
    private queryTerms = getQueryTerms();
    private searchConfig = getSearchConfiguration();
    private UIComponents = getUIComponents();
    private invokeAutomaticSearch = getAttributesMap().tabsRemote;
    private vid: string = getVid();
    private scopesOptions: any[];
    private selectedSearchTab: string;
    private scope: string;
    private limit: number = 2;
    private isDateRange: boolean = false;
    private rowArray: queryRow[];
    private _signInAlert: IAlertMsg;
    private error: boolean = false;
    private startDay: filter;
    private endDay: filter;
    private startMonth: filter;
    private endMonth: filter;
    private startYear = '';
    private endYear = '';
    private dispalyServerMap: any;
    private serverDispalyMap: any;
    private searchOperator: string;
    private clearForm: boolean;
    private serachOptions: any;
    private searchCategory: string;
    private searchCategoryOptions: any;
    private searchCategoryOptionsInit: any;
    private selectedLanguage: any;
    private boolOperator: string;
    private boolOptions: any;
    private language: filter;
    private materialType: filter;
    private publicationData: filter;
    private tabTileMapping: Object;
    private errorCode: string;
    private yearRegex = '-?\\d+';
    private sortby: string;
    private langsList = [];
    private langsMap: { [key: string]: string; } = {};
    private isDayOrMonthListIsOpen: boolean = false;
    private selectedComp: string = '';
    private isIe = isBrowserIE();
    private _openCloseSearchFilterButton: boolean = true;    
    private equalsPhraseCategories: any;
	private ENABLE_BARCODE_SEARCH: string = "enable_barcode_search";
    private sectionNameToTabIndex: Object = {'searchCriteria': 0, 'barcode': 1};
    private selectedTabIndex: number;
    private BARCODE_SEARCH_TAB = "barcode";
    private EqualsPhraseFields: string[] = ['title', 'sub', 'creator'];
    private disableCategoryField : boolean= false;
    private KEY_CODE = {
        ENTER: 13,
    };

    constructor(@Inject('$mdDateLocale') private $mdDateLocaleProvider: ng.material.IDateLocaleProvider,
                private searchService: SearchService,
                private searchFieldsService: SearchFieldsService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                private searchBarService: SearchBarService,
                private alertService: AlertFactory,
                private primolyticsService: PrimolyticsService,
                private smoothScrollUtil: SmoothScrollUtil,
                @Inject('$state') private $state: ng.ui.IStateService,
                private configurationUtil: ConfigurationUtil,
                private jwtUtilService: JwtUtilService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$translate') private $translate,
                @Inject('I18nService') private i18nService,
                @Inject('$location') private $location: ng.ILocationService,
                private mediaQueries: MediaQueries,
                private mappingTablesCache: MappingTablesCache,
                private advancedSearchService: AdvancedSearchService,
                private barcodeService: BarcodeSearchService
    ) {
        this.selectedLanguage = i18nService.getLanguage();
        this.selectedTabIndex = this.setSelectedAdvancedSearchTab(this.$stateParams.searchType); //set selected tab from deep link
    }

    ngOnInit() {
		this.disableCategoryField = false;
        this.errorCode = '';
        this.initSelectedTab();
        this.scopesOptions = this.getScopesOptionsByTab(this.selectedSearchTab);
        this.initSelectedScope();
        this.dispalyServerMap = {};
        this.serverDispalyMap = {};
        this.filterTabByEmptyScope();
        this.getComplexLine();
        this.fillComplexLineFromUrl();
        this.$scope.$on('$stateChangeSuccess', (event, toState) => {
            if (toState.name === STATE_NAMES.SEARCH) {
                this.initRowArray();
                this.fillComplexLineFromUrl();
            }
        });
        this.fillPreFiltersFromUrl();
        if (!this.isAdvanced() && this.typedQuery) {
            this.rowArray[0].searchQuery = this.typedQuery;
        }

        this._signInAlert = this.alertService.create(ALERT_MSG_TYPE.SIGNIN);
        this._signInAlert.show('nui.search.tnsearch.error.authorization');
        this.smoothScrollUtil.focusOn('advanced-search');
        this.$scope.$watch(() => this.rowArray[0].searchQuery, () => {
            this.typedQuery = this.rowArray[0].searchQuery
        });

        this.openCloseSearchFilterButton = !this.advancedSearchCollapsed;
    }


    private initSelectedScope() {
        if (this.selectedScope) {
            this.scope = this.selectedScope;
            return;
        }
        if (this.isAdvanced() && this.$stateParams['search_scope'] && this.scopesOptions.indexOf(this.$stateParams['search_scope']) === -1) {
            this.error = true;
        } else if (this.isAdvanced() && this.$stateParams['search_scope'] && this.scopesOptions.indexOf(this.$stateParams['search_scope']) !== -1) {
            this.scope = this.$stateParams['search_scope'];
        }
    }

    private isAdvanced() {
        if (this.searchFieldsService.searchParams && this.searchFieldsService.searchParams['mode'] === 'advanced') {
            return true;
        }
        return false;
    }
	public isSuprima(){
		return getBackendSystem() === 'suprima';
	}
	
    private filterTabByEmptyScope() {
        this.searchTabs = this.searchTabs.filter((tab) => {
            if (!isEmpty(this.getScopesOptionsByTab(tab))) {
                return tab;
            }
        });
    }

    private initSelectedTab() {
        if (this.selectedTab) {
            this.selectedSearchTab = this.selectedTab;

        } else {
            if (this.$stateParams['tab'] && this.searchTabs.indexOf(this.$stateParams['tab']) === -1) {
                this.error = true;
            } else if (this.$stateParams['tab'] && this.searchTabs.indexOf(this.$stateParams['tab']) !== -1) {
                this.selectedSearchTab = this.$stateParams['tab'];
            } else if (!this.$stateParams['tab']) {
                this.selectedSearchTab = this.searchTabs[0];
            }
        }

    }


    private initRowArray() {
        this.rowArray = [
               { boolOperator:  this.boolOperator, searchOperator: this.searchOperator, searchCategory: this.searchCategory, searchQuery: ''},
               { boolOperator:  this.boolOperator, searchOperator: this.searchOperator, searchCategory: this.searchCategory,searchQuery: ''},
               { boolOperator:  this.boolOperator, searchOperator: this.searchOperator, searchCategory: this.searchCategory,searchQuery: ''},
               { boolOperator:  this.boolOperator, searchOperator: this.searchOperator, searchCategory: this.searchCategory, searchQuery: ''},
               { boolOperator:  this.boolOperator, searchOperator: this.searchOperator, searchCategory: this.searchCategory, searchQuery: ''},
               { boolOperator:  this.boolOperator, searchOperator: this.searchOperator, searchCategory: this.searchCategory,searchQuery: ''},
               { boolOperator:  this.boolOperator, searchOperator: this.searchOperator, searchCategory: this.searchCategory,searchQuery: ''}
        ];
    }


    private filterEmpty(scope) {
        if (scope !== '') {
            return scope;
        }
    }

    /**
     * Get the a scope list of the specific tab
     * Set the default scope to be the first scope in the list
     */

    public getScopesOptionsByTab(tab) {
        let scopesOptions = this.scopes.map((scope) => {
            if (scope.tab === tab) {
                return scope['scope-id'];
            }

        }).filter(this.filterEmpty);
        return uniq(scopesOptions);
    }

    private setScopes() {
        this.scopesOptions = this.getScopesOptionsByTab(this.selectedSearchTab);
        this.scope = this.scopesOptions[0];
    }


    public changeSearchFields() {
        this.clearForm = false;
        this.errorCode = '';
        this.setScopes();
        this.getComplexLine();
        if (this.invokeAutomaticSearch === 'true' && this.textAppears()) {
            this.search();
        }
        this.updateFindInDbEvent.emit(this.selectedSearchTab);

    }


    /**
     * Given a tab get the first complex line to get the query line fields
     * Get the pre-filter line fields
     *
     */
    public getComplexLine() {
        let prevTabArray = this.rowArray;
        this.dispalyServerMap = {};
        this.serverDispalyMap = {};
        this.searchOperator = '';
        this.serachOptions = [];
        this.searchCategory = '';
        this.searchCategoryOptions = [];
        this.searchCategoryOptionsInit = [];
        this.boolOperator = '';
        this.boolOptions = [];
        this.langsList = [];
        //let str = this.tabTileMapping[this.selectedSearchTab];

        let tabToTile = this.configurationUtil.getTile('SearchTileInterface-Advanced', getTabToTiles(this.selectedSearchTab));
        let qtvInstance = this.searchConfig[tabToTile].qtvinstance;
        let alphabeticLanguagesSort = this.searchConfig[tabToTile].alphabeticLanguagesSort;
        let complexLines = this.complexLines(qtvInstance);
        if (complexLines.length > 0) {
            let complexLineVid = complexLines[0];
            let queryTerm = this.queryTerms[complexLineVid];

            if (!this.UIComponents.boolOperator) {
                this.UIComponents.boolOperator = {
                    defaultOption: 'AND',
                    displayOptions: ['AND', 'OR', 'NOT'],
                    options: ['AND', 'OR', 'NOT'],
                    indexFields: ['AND', 'OR', 'NOT']
                };
            }

            this.boolOperator = this.UIComponents.boolOperator.defaultOption;
            this.boolOptions = this.UIComponents.boolOperator.displayOptions;

            this.updateMapWithPrecisionBoolOperator(this.UIComponents.boolOperator);
            let uiComp = queryTerm.map((comp) => {
                if (comp !== 'freeText' && comp !== 'boolOperator') {
                    return comp;
                }
            })
                .filter(this.filterEmpty);
            for (let i = 0; i < uiComp.length; i++) {
                if (this.UIComponents[uiComp[i]] && this.UIComponents[uiComp[i]].type['_string'] === 'precisionOperator') {
                    this.searchOperator = this.UIComponents[uiComp[i]].defaultOption;
                    this.serachOptions = this.UIComponents[uiComp[i]].displayOptions;
                    this.updateMapWithPrecisionBoolOperator(this.UIComponents[uiComp[i]]);
                } else if (this.UIComponents[uiComp[i]] && this.UIComponents[uiComp[i]].type['_string'] === 'scope') {
                    this.searchCategory = this.getDefaultSerachCategory(this.UIComponents[uiComp[i]].defaultOption,
                        this.UIComponents[uiComp[i]].displayOptions);
                    // 7 is by hsrcoded array in initRowArray
                    for(let j=0; j<7; j++){
	                    this.searchCategoryOptions[j] = this.UIComponents[uiComp[i]].displayOptions;
	                    this.searchCategoryOptionsInit[j] = this.UIComponents[uiComp[i]].displayOptions;
                    }
                    this.updateMapWithIndexField(this.UIComponents[uiComp[i]]);
                }
            }
            this.equalsPhraseCategories = this.searchCategoryOptionsInit[0].filter(category => this.EqualsPhraseFields.indexOf(category) > -1);
            this.initRowArray();
            if (prevTabArray) {
                this.copyRowsFromTabToTab(prevTabArray);
            }
        }
        let prevLang = this.language ? this.language.selection : '';
        let prevMaterial = this.materialType ? this.materialType.selection : '';
        let prevPublication = this.publicationData ? this.publicationData.selection : '';
        let prevStartDay = this.isDateRange ? this.startDay.selection : '';
        let prevStartMonth = this.isDateRange ? this.startMonth.selection : '';
        let prevEndDay = this.isDateRange ? this.endDay.selection : '';
        let prevEndMonth = this.isDateRange ? this.endMonth.selection : '';
        let prevStartYear = this.isDateRange && this.startYear ? this.startYear : '';
        let prevEndYear = this.isDateRange && this.endYear ? this.endYear : '';

        this.language = this.getPreFilterByType(qtvInstance, '.language');
        if (!isEmpty(this.language)) {
            this.language.displayOptions.map((lang) => {
                this.$translate('search-advanced.language.option.' + lang).then((translation) => {
                    this.langsList.push(translation);
                    this.langsMap[translation] = lang;
                    //this.langsList.sort((a,b) => a.localeCompare(b, this.selectedLanguage));
                    if (alphabeticLanguagesSort) {
                        let sorter = new Intl.Collator(this.selectedLanguage, {usage: "sort"});
                        this.langsList.sort(sorter.compare);
                    }
                });
            });
        }
        this.materialType = this.getPreFilterByType(qtvInstance, '.mediaType');
        this.publicationData = this.getPreFilterByType(qtvInstance, '.publicationData');
        this.isDateRange = this.getDateRangeFilter(qtvInstance);

        if (!isEmpty(this.publicationData) && this.isDateRange) {
            this.publicationData.displayOptions.splice(1, 0, 'specificDate');
            this.publicationData.options.splice(1, 0, 'specificDate');
        }

        if (prevLang && !isEmpty(this.language) && this.language.displayOptions.indexOf(prevLang) !== -1) {
            if (this.language.selection !== prevLang) {
                this.clearForm = true;
            }
            this.language.selection = prevLang;
        }
        if (prevMaterial && !isEmpty(this.materialType) && this.materialType.displayOptions.indexOf(prevMaterial) !== -1) {
            if (this.materialType.selection !== prevMaterial) {
                this.clearForm = true;
            }
            this.materialType.selection = prevMaterial;
        }
        if (prevPublication && !isEmpty(this.publicationData) && this.publicationData.displayOptions.indexOf(prevPublication) !== -1) {
            if (this.publicationData.selection !== prevPublication) {
                this.clearForm = true;
            }
            this.publicationData.selection = prevPublication;
        }
        if (this.isDateRange) {
            if (prevStartDay) {
                this.startDay.selection = prevStartDay;
            }
            if (prevStartMonth) {
                this.startMonth.selection = prevStartMonth;
            }
            if (prevEndDay) {
                this.endDay.selection = prevEndDay;
            }
            if (prevEndMonth) {
                this.endMonth.selection = prevEndMonth;
            }
            this.startYear = prevStartYear;
            this.endYear = prevEndYear
            if (this.isDate()) {
                this.clearForm = true;
                if (!isEmpty(this.publicationData) && !prevPublication) {
                    this.publicationData.selection = 'specificDate';
                }
            }
        }
    }


    private copyRowsFromTabToTab(oldTabArray) {
        let count = 0;
        for (let i = 0; i < this.limit; i++) {
            if (oldTabArray[i].searchQuery) {
                if (this.boolOptions.indexOf(oldTabArray[i].boolOperator) !== -1) {
                    this.rowArray[i].boolOperator = oldTabArray[i].boolOperator;
                }
                if (this.serachOptions.indexOf(oldTabArray[i].searchOperator) !== -1) {
                    this.rowArray[i].searchOperator = oldTabArray[i].searchOperator;
                }
                if (this.searchCategoryOptions[i].indexOf(oldTabArray[i].searchCategory) !== -1) {
                    this.rowArray[i].searchCategory = oldTabArray[i].searchCategory;
                }
                this.rowArray[i].searchQuery = oldTabArray[i].searchQuery;
                count = i;
                this.clearForm = true;
            }
        }
        this.limit = Math.max(2, count + 1);
    }


    private fillComplexLineFromUrl() {
        let queries = this.$stateParams['query'];
        if (queries) {
            queries = flatten([queries]);
            this.rowArray[0].boolOperator = 'AND';
            queries.forEach((query, index, array) => {
                //arr contains elements from type 'any,contains,a,AND'
                let arr = query.split(',');
                this.rowArray[index].searchCategory = this.serverDispalyMap[arr[0]] ? this.serverDispalyMap[arr[0]].display : arr[0];
                this.rowArray[index].searchOperator = this.serverDispalyMap[arr[1]] ? this.serverDispalyMap[arr[1]].display : arr[1];
                let str = arr[2];
                if (arr.length > 3) {
                    let newArr = arr.slice(2, arr.length - 1);
                    str = newArr.join(",");
                }
                this.rowArray[index].searchQuery = str;
                if (index + 1 < this.rowArray.length) {
                    this.rowArray[index + 1].boolOperator = 'AND';
                    if (arr[arr.length - 1] && get(this.serverDispalyMap[arr[arr.length - 1]], 'display')) {
                        this.rowArray[index + 1].boolOperator = get(this.serverDispalyMap[arr[arr.length - 1]], 'display');
                    }
                }
            });
            if (queries.length > 2) {
                this.limit = queries.length;
            }
        }
    }

    private fillPreFiltersFromUrl() {
        let preFilter = this.$stateParams['pfilter'];
        if (preFilter) {
            preFilter = flatten([preFilter]);
            let firstCdateHit = false;
            preFilter.forEach((filter, index, array) => {
                let arr = filter.split(',');
                if (arr[0] === 'lang') {
                    this.language.selection = this.getPreFilterFordisplay(this.language, arr[2]);
                } else if (arr[0] === 'pfilter' || arr[0] === 'rtype') {
                    this.materialType.selection = this.getPreFilterFordisplay(this.materialType, arr[2]);
                } else if (arr[0] === 'creationdate') {
                    this.publicationData.selection = this.getPreFilterFordisplay(this.publicationData, arr[2]);
                } else if (arr[0] === 'dr_s' || (arr[0] === 'cdate' && !firstCdateHit)) {
                    if (!isEmpty(this.publicationData)) {
                        this.publicationData.selection = 'specificDate';
                    }
                    this.startYear = arr[2].substring(0, arr[2].length - 4);
                    this.startMonth.selection = arr[2].substring(arr[2].length - 4, arr[2].length - 2);
                    this.startDay.selection = arr[2].substring(arr[2].length - 2, arr[2].length);
                    firstCdateHit = true;
                } else if (arr[0] === 'dr_e' || (arr[0] === 'cdate' && firstCdateHit)) {
                    this.endYear = arr[2].substring(0, arr[2].length - 4);
                    this.endMonth.selection = arr[2].substring(arr[2].length - 4, arr[2].length - 2);
                    this.endDay.selection = arr[2].substring(arr[2].length - 2, arr[2].length);

                }
            });
        }
    }

    private updateMapWithIndexField(UIComp) {
        if (UIComp.displayOptions) {
            UIComp.displayOptions.forEach((item, index, array) => {
                this.dispalyServerMap[item] = {'send': UIComp.indexFields[index]};
            });
        }
        if (UIComp.indexFields) {
            UIComp.indexFields.forEach((item, index, array) => {
                this.serverDispalyMap[item] = {'display': UIComp.displayOptions[index]};
            });
        }
    }

    private updateMapWithPrecisionBoolOperator(UIComp) {
        if (UIComp.displayOptions) {
            UIComp.displayOptions.forEach((item, index, array) => {
                    this.dispalyServerMap[item] = {'send': UIComp.options[index]};
                }
            );
        }
        if (UIComp.options) {
            UIComp.options.forEach((item, index, array) => {
                this.serverDispalyMap[item] = {'display': UIComp.displayOptions[index]};
            });
        }

    }

    private getDefaultSerachCategory(defaultOption, options) {
        let defaultSerachCategory = '';
        if (defaultOption.length > 0) {
            defaultSerachCategory = defaultOption;
        } else {
            defaultSerachCategory = options[0];
        }
        return defaultSerachCategory;

    }

    private showDateRange() {
        if (isEmpty(this.publicationData) && !isEmpty(this.isDateRange)) {
            return true;
        } else {
            return false;
        }
    }

    private getPreFilterByType(qtvInstance, str) {
        let preFilter = qtvInstance.map((obj) => {
            if (obj.qtvid.includes(str) && this.queryTerms[obj.qtvid]) {
                return this.UIComponents[this.queryTerms[obj.qtvid][0]];
            }
        }).filter(this.filterEmpty)[0];


        if (preFilter) {
            let displayOptions = uniq(preFilter.displayOptions.slice());
            let defaultOption = preFilter.defaultOption ? preFilter.defaultOption : displayOptions[0];

            let filter = {
                'label': preFilter.type['_string'],
                'options': uniq(preFilter.options.slice()),
                'displayOptions': displayOptions,
                'indexField': preFilter.indexFields[0],
                defaultOption: defaultOption,
                selection: defaultOption

            };
            return filter;
        }
        return {};
    }


    private getDateRangeFilter(qtvInstance) {
        let dateRange = qtvInstance.map((obj) => {
            if (obj.qtvid.includes('.date_range')) {
                return this.queryTerms[obj.qtvid];
            }
        }).filter(this.filterEmpty);

        if (isEmpty(dateRange)) {
            return false;
        }
        let dateRangeScope = dateRange[0].map((obj) => {
            return this.UIComponents[obj];
        });
        this.startDay = this.getDate(dateRangeScope, 'drStartDay');
        this.startDay.selection = this.startDay.defaultOption;
        this.endDay = this.getDate(dateRangeScope, 'drEndDay');
        this.endDay.selection = this.endDay.defaultOption;
        this.startMonth = this.getDate(dateRangeScope, 'drStartMonth');
        this.startMonth.selection = this.startMonth.defaultOption;
        this.endMonth = this.getDate(dateRangeScope, 'drEndMonth');
        this.endMonth.selection = this.endMonth.defaultOption;
        this.startYear = '';
        this.endYear = '';
        return true;
    }


    /* validation of date:
    month without a year, or day without a month/year is not legal
    end date needs to be greater than start date */
    private isDateValid() {
        let errorCode = '';
        this.startYear = this.changeDate(this.startYear);
        this.endYear = this.changeDate(this.endYear);
        //allow only combination of year, year+month, year+month+day
        if ((this.startDay.selection !== 'start_day' && this.startMonth.selection === 'start_month') ||
            (this.startMonth.selection !== 'start_month' && this.startYear === '')) {
            errorCode = 'search.search.error.startDateInvalid';
        } else if ((this.endDay.selection !== 'end_day' && this.endMonth.selection === 'end_month') ||
            (this.endMonth.selection !== 'end_month' && this.endYear === '')) {
            errorCode = 'search.search.error.endDateInvalid';
        } else if (!this.isLegalDate(this.startYear) || !this.isLegalDate(this.endYear)) {
            errorCode = 'search.search.error.yearOutOfRange';
        } else if (this.startYear !== '' && this.endYear !== '') {
            let startYear = parseInt(this.startYear);
            let endYear = parseInt(this.endYear);
            if (endYear < startYear) {
                errorCode = 'search.search.error.startLaterThanEnd';
            } else if (endYear === startYear && this.startMonth.selection !== 'start_month' &&
                this.endMonth.selection !== 'end_month') {
                if (this.endMonth.selection < this.startMonth.selection) {
                    errorCode = 'search.search.error.startLaterThanEnd';
                } else if (this.startMonth.selection === this.endMonth.selection &&
                    this.startDay.selection != 'start_day' && this.endDay.selection != 'end_day') {
                    if (this.endDay.selection < this.startDay.selection) {
                        errorCode = 'search.search.error.startLaterThanEnd';
                    }
                }
            }
        }
        // if there isn't start year- it is '0000' so there can not be minus date in end date
        else if (this.startYear === '' && this.endYear !== '' && this.isBcDate(this.endYear)) {
            errorCode = 'search.search.error.startLaterThanEnd';
        }
        return errorCode;

    }

    /* if the year is not bc year and contains 5 characters (length can be maximum 5 characters- there is a restriction in html)
    this is not legal only if the first character is different from '0'
    the number '00001' for example is legal
    */
    private isLegalDate(year) {
        if (year != '' && ((this.isBcDate(year) && year.length > 5) || (!this.isBcDate(year) && year.length > 4 && year.substring(0, 1) !== '0'))) {
            return false;
        }
        return true;
    }

    private isBcDate(year) {
        return year && year.indexOf('-') === 0;
    }


    private isDate() {
        if (this.startDay.selection === 'start_day' && this.startMonth.selection === 'start_month' &&
            this.startYear === '' && this.endDay.selection === 'end_day' &&
            this.endMonth.selection === 'end_month' && this.endYear === '') {
            return false;
        }
        return true;
    }


    private getDate(dateRangeScope, str) {
        return dateRangeScope.filter((obj) => {
            if (obj.type['_string'] === str) {
                return obj;
            }
        })[0];
    }


    private complexLines(qtvInstance) {
        let complexLines = qtvInstance.map((obj) => {
            if (obj.qtvid.includes('searchbox_complex')) {
                return obj.qtvid;
            }
        }).filter(this.filterEmpty);
        return complexLines;

    }

    private incrementLimit() {
        this.limit += 1;
        this.clearForm = true;
    }

    /**
     * Restore the default values of the tab
     */
    private clearSearchForm() {
        this.initRowArray();
        this.scope = this.scopesOptions[0];
        this.clearForm = false;
        this.errorCode = '';
        this.limit = 2;
        if (!isEmpty(this.language)) {
            this.language.selection = this.language.defaultOption;
        }
        if (!isEmpty(this.materialType)) {
            this.materialType.selection = this.materialType.defaultOption;
        }
        if (!isEmpty(this.publicationData)) {
            this.publicationData.selection = this.publicationData.defaultOption;
        }
        if (this.isDateRange) {
            this.startDay.selection = 'start_day';
            this.startMonth.selection = 'start_month';
            this.startYear = '';
            this.endDay.selection = 'end_day';
            this.endMonth.selection = 'end_month';
            this.endYear = '';
        }
    }


    private specificDate() {
        if ((isEmpty(this.publicationData) && this.isDateRange) ||
            (!isEmpty(this.publicationData) && this.publicationData.selection === 'specificDate')) {
            return true;
        }
        return false;
    }

    private onChange() {
        this.clearForm = true;
    }

    private onOpen() {
        this.isDayOrMonthListIsOpen = true;
    }

    private onClose() {
        this.isDayOrMonthListIsOpen = false;
    }

    getPlaceHolders() {
        return {idx_0: this.selectedCompStr};
    }

    public setSelectedCompStr(str: string) {
        this.selectedComp = str;
    }

    get selectedCompStr() {
        return this.selectedComp;
    }

    private changeOperator(index) {
        let ind=index>this.searchCategoryOptionsInit.length-1?0:index;
        this.setSearchCategoriesOptions(this.rowArray[index].searchOperator, ind);
        if (this.rowArray[index].searchOperator === 'startswith') {
			if (this.searchCategoryOptions[ind].length !== 0 && this.searchCategoryOptions[ind].indexOf(this.rowArray[index].searchCategory) ===-1){
				this.rowArray[index].searchCategory = this.searchCategoryOptions[ind][0];
			}
        } 
		if (this.rowArray[index].searchOperator === 'equalsPhrase') {
			if(this.EqualsPhraseFields.indexOf(this.rowArray[index].searchCategory) === -1){
				this.rowArray[index].searchCategory = this.equalsPhraseCategories[0];
			}
		}
        
        this.clearForm = true;
        this.changeSortbyForOperator(this.rowArray[index].searchOperator, this.rowArray[index].searchCategory);
    }
    
    setSearchCategoriesOptions(operator, ind){
		if(operator === 'startswith'){
			let fields = ['title'];
			if(this.isSuprima()){
				if(getAllowStartWithForCallNumber()){
					fields.push('holding_call_number');
					this.disableCategoryField = false;
				}else{
					this.disableCategoryField = true;
				}
			}else{
				fields.push('callnumber');
				this.disableCategoryField = false;
			}
			this.searchCategoryOptions[ind] = this.searchCategoryOptionsInit[ind].filter(category => (fields.indexOf(category) > -1));
			if(this.searchCategoryOptions[ind].length === 0){
				this.searchCategoryOptions[ind]=this.searchCategoryOptionsInit[ind];
				this.disableCategoryField = true;
			}
		}else{
			this.searchCategoryOptions[ind] = this.searchCategoryOptionsInit[ind];
		}
	}


    getOperatorTitle(operator){
        if(operator === 'equalsPhrase'){
            return this.$translate.instant('search-advanced.precisionOperator.option.equalsPhraseTitle');
        }else if(operator === 'startswith'){
            return this.$translate.instant('search-advanced.precisionOperator.option.startswithTitle');
        }else{
            return "";
        }
    }

    getOperatorAria(operator){
        let operatorName = this.$translate.instant('search-advanced.precisionOperator.option.' + operator);
        let operatorAria = this.$translate.instant('nui.aria.search.operator', {operator_name: operatorName});
        if(operator === 'equalsPhrase'){
            return operatorAria + ' ' + this.$translate.instant('nui.aria.search.equalsPhraseAria');
        }else if(operator === 'startswith'){
            return operatorAria + ' ' + this.$translate.instant('nui.aria.search.startswithAria');
        }else{
            return operatorAria;
        }
    }

    getSearchCategoryOptions(index){
        let ind=index>this.searchCategoryOptionsInit.length-1?0:index;
        if (this.rowArray[index].searchOperator === 'equalsPhrase') {
			this.equalsPhraseCategories = this.searchCategoryOptionsInit[ind].filter(category => (this.EqualsPhraseFields.indexOf(category) > -1));
       		return this.equalsPhraseCategories;
      	}
      	if(this.rowArray[index].searchOperator === 'startswith'){
	        this.changeSortbyForOperator(this.rowArray[index].searchOperator, this.rowArray[index].searchCategory);
		}
      	this.setSearchCategoriesOptions(this.rowArray[index].searchOperator, ind);
        return this.searchCategoryOptions[ind];
    }

    private changeSortbyForOperator(searchOperator, searchCategory) {
        switch (searchOperator) {
            case 'startswith':
            	if(searchCategory ==='title'){
               		this.sortby = 'title';
           	 	}else{
					this.sortby = 'rank';
				}
                break;
            case 'contains':
                this.sortby = 'rank';
                break;
            case 'exact':
                this.sortby = 'rank';
                break;
            case 'equalsPhrase':
                this.sortby = 'rank';
                break;
            default :
                this.sortby = 'rank';
        }
    }

    private textAppears() {
        if (this.rowArray[0].searchQuery || this.rowArray[1].searchQuery || this.rowArray[2].searchQuery || this.rowArray[3].searchQuery
            || this.rowArray[4].searchQuery || this.rowArray[5].searchQuery || this.rowArray[6].searchQuery) {
            return true;
        }
        return false;
    }

    public search() {
        this.errorCode = '';
        if (this.specificDate() && this.isDate()) {
            this.errorCode = this.isDateValid();
        }
        //false if empty string
        if (!this.errorCode && this.textAppears()) {
            let searchParams = this.createQuery();
            this.searchFieldsService.scope = this.scope;
            this.selectedScope = this.scope;
            this.searchFieldsService.tab = this.selectedSearchTab;
            this.selectedTab = this.selectedSearchTab;
            this.showTabAndScopes = true;
            this.typedQuery = this.rowArray[0].searchQuery;
            this.goToSearch(searchParams.query);

            if ((this.advancedSearchService.getSessionAdvancedSearchMode() !='expanded' && this.openCloseSearchFilterButton) ||
            (this.advancedSearchService.getSessionAdvancedSearchMode() =='expanded' && !this.openCloseSearchFilterButton)){    //for the case we have a collapsed advanced search, but the value was changed to "expanded" in another tab
                this.toggleFilters(true);
            }
        }
    }

    private goToSearch(query: string) {
        let queryArr = query.split(';');
        let queryA = queryArr.filter((query) => !query.match('(facet_|dr_s|dr_e|lang|rtype).*,exact,.*,AND'));
        let pfilter = queryArr
            .filter((query) => query.match('(facet_|dr_s|dr_e|lang|rtype).*,exact,.*,AND'))
            .map((query) => query.replace('facet_', ''));

        let params: any = {
            mode: 'advanced',
            vid: this.vid,
            query: queryA,
            pfilter: pfilter,
            tab: this.selectedTab,
            search_scope: this.selectedScope,
            facet: [],
            mfacet: [],
            offset: 0
        };
        if (this.sortby) {
            params.sortby = this.sortby;
            this.sortby = '';
        }
        if (this.searchFieldsService.prevSortByAdvanced) { // PRM-41439 - sort selection saved for advance search unless we came from frbr group
            params.sortby = this.searchFieldsService.prevSortByAdvanced;
            this.searchFieldsService.prevSortByAdvanced = undefined;
        }
        this.searchFieldsService.searchParams = params;
        this.$state.go(STATE_NAMES.SEARCH, params, {reload: STATE_NAMES.SEARCH});
    }

    private createQuery() {
        let query = this.getQueriesWithText();
        let pfilter = '';
        if (!isEmpty(this.language) && this.language.selection !== 'all_items' && this.language.selection !== 'any') {
            query += this.language.indexField + ',' + 'exact,' + this.getPreFilterForServer(this.language) + ',' + 'AND;';
        }
        if (!isEmpty(this.materialType) && this.materialType.selection !== 'all_items' && this.materialType.selection !== 'any') {
            query += this.materialType.indexField + ',' + 'exact,' + this.getPreFilterForServer(this.materialType) + ',' + 'AND;';
        }
        if (!isEmpty(this.publicationData) && this.publicationData.selection !== 'all_items' && this.publicationData.selection !== 'specificDate') {
            query += this.publicationData.indexField + ',' + 'exact,' + this.getPreFilterForServer(this.publicationData) + ',' + 'AND;';
        } else if (this.specificDate() && this.isDate()) {
            this.fillEmptyDateFields();
            this.startYear = this.zeroPadYear(this.startYear);
            this.endYear = this.zeroPadYear(this.endYear);
            let startRangeDate = this.startDay.indexFields[0] === "cdate" ? "dr_s" : this.startDay.indexFields[0];
            query += startRangeDate + ',' + 'exact,' + this.startYear + this.getPreFilterForServer(this.startMonth)
                + this.getPreFilterForServer(this.startDay) + ',' + 'AND;';
            let endRangeDate = this.endDay.indexFields[0] === "cdate" ? "dr_e" : this.endDay.indexFields[0];
            query += endRangeDate + ',' + 'exact,' + this.endYear + this.getPreFilterForServer(this.endMonth)
                + this.getPreFilterForServer(this.endDay) + ',' + 'AND;';

        }
        query = query.slice(0, -1);
        return {'query': query};
    }

    // -0000 becomes 0000
    private changeDate(year) {
        //year is undefined when the user inserts illegal characters in this input field
        if (!year) {
            year = '';
        } else if (year && year.match('^-?0{0,4}0$')) {
            year = '0000';
        }
        return year;
    }


    private zeroPadYear(year) {
        let isMinus = this.isBcDate(year);
        if (isMinus) {
            year = year.substr(1);
        }
        if (year.length === 1) {
            year = '000' + year;
        } else if (year.length === 2) {
            year = '00' + year;
        } else if (year.length === 3) {
            year = '0' + year;
        }
        /*if we got to this point, this means that the year is valid. it has 5 characters when this is not bc date only
            in the case of '00001' for example
            so we need to remove the first '0'
         */
        else if (year.length === 5) {
            year = year.slice(1);
        }
        if (isMinus) {
            year = '-' + year;
        }
        return year;
    }


    private fillEmptyDateFields() {
        let isStartYearBc = this.isBcDate(this.startYear);
        let isEndYearBc = this.isBcDate(this.endYear);
        if (this.startDay.selection === 'start_day' || isStartYearBc) {
            this.startDay.selection = '01';
        }
        if (this.startMonth.selection === 'start_month' || isStartYearBc) {
            this.startMonth.selection = '01';
        }
        if (this.startYear === '') {
            this.startYear = '0000';
        }
        if (this.endDay.selection === 'end_day' || isEndYearBc) {
            this.endDay.selection = '31';
        }
        if (this.endMonth.selection === 'end_month' || isEndYearBc) {
            this.endMonth.selection = '12';
        }
        if (this.endYear === '') {
            this.endYear = '9999';
        }
    }


    private getQueriesWithText() {
        let text = this.rowArray.filter((item) => item.searchQuery);
        let query = '';
        text.forEach((item, index, array) => {
            if (text[index].searchQuery) {
                query += this.getParamForServer(text[index].searchCategory) + ',' +
                    this.getParamForServer(this.getSearchOperator(text[index].searchOperator)) + ',' +
                    text[index].searchQuery.split(';').join(' ') + ',';
                if (index + 1 < text.length) {
                    query += this.getParamForServer(text[index + 1].boolOperator) + ';';
                } else {
                    query += 'AND;';
                }
            }
        });
        return query;
    }


    private getPreFilterForServer(preFilter) {
        let index = preFilter.displayOptions.indexOf(preFilter.selection);
        if (index !== -1) {
            return preFilter.options[index];
        }
        return preFilter;
    }

    private getPreFilterFordisplay(preFilter, option) {
        let index = preFilter.options.indexOf(option);
        //illegal parameter in 'pfilter', return the default value
        if (index === -1) {
            this.error = true;
            return preFilter.selection;
        }
        return preFilter.displayOptions[index];
    }


    private getLangCode(language) {
        return this.langsMap[language];
    }

    private getParamForServer(field) {
        if (this.dispalyServerMap[field]) {
            return this.dispalyServerMap[field].send;
        }
        return field;
    }

    private getSearchOperator(operator) { //the default is contains, the only parameter that can be empty
        if (operator !== '') {
            return operator;
        }
        return 'contains';
    }

    private getCodeForPublicationDate(publication) {
        if (publication === 'specificDate') {
            return 'nui.search-advanced.publicationDate.option.';
        }
        return 'search-advanced.publicationDate.option.';
    }

    private firstQuery() {
        for (let i = 0; i < this.rowArray.length; i++) {
            if (this.rowArray[i].searchQuery) {
                return i;
            }
        }
        return -1;
    }

    get signInAlert(): IAlertMsg {
        return this._signInAlert;
    }

    get showSignIn() {
        return this.searchBarService.showSignIn;
    }

    private isSignedIn() {
        return this.jwtUtilService.isSignedIn();

    }

    get isEdgeOrIE() {
        return isBrowserIE() || isBrowserEdge();
    }

    public removeReadonly(event) {
        if (this.isEdgeOrIE) {
            event.target.readOnly = false;
        }
    }

    public addReadonly(event) {
        if (this.isEdgeOrIE) {
            event.target.readOnly = true;
        }
    }

    public toggleFilters(fromSearch: boolean) {
        this.openCloseSearchFilterButton = !this.openCloseSearchFilterButton;
        let advancedSearchCollapsed = this.openCloseSearchFilterButton ? false : true;
        let advancedSearchParams = { 'advancedSearchCollapsed': advancedSearchCollapsed };
        this.updateAdvancedSearchParams.emit(advancedSearchParams);

        if (!fromSearch) { // Only if we came from the "Search Criteria" button:
            this.openCloseSearchFilterButton ? this.runBeacon('advancedSearchExpanded') : this.runBeacon('advancedSearchCollapsed');
            this.openCloseSearchFilterButton ? this.advancedSearchService.setSessionAdvancedSearchMode('expanded'):this.advancedSearchService.setSessionAdvancedSearchMode('collapsed');
            if (this.advancedSearchService.isLoggedIn()){        // if the user is signed-in, save the selection also to DB
                this.openCloseSearchFilterButton ? this.advancedSearchService.saveUserSelectionToDB('expanded'):this.advancedSearchService.saveUserSelectionToDB('collapsed');
            }
         }
    }

    get openCloseSearchFilterButton(): boolean {
        return this._openCloseSearchFilterButton;
    }

    set openCloseSearchFilterButton(value: boolean) {
        this._openCloseSearchFilterButton = value;
    }

    private runBeacon(operation) {
		this.primolyticsService.doBeaconReport({
			'p': 'search',
			'op': operation
		}, this.primolyticsService.getTimestamp());
	}
    private getAriaLabel(type: string) {
        switch (type) {
            case 'startDay':
                if(this.startDay.selection=="start_day"){
                    return this.$translate.instant('search-advanced.DateRange.label.DateRangeStart') + ' ' + this.$translate.instant('nui.aria.advanced.dateStart');
                }
                else{
                    return this.$translate.instant('search-advanced.DateRange.label.DateRangeStart') + ' ' + this.$translate.instant('nui.aria.advanced.dateStart') + ' ' + this.$translate.instant('nui.aria.advanced.dateDay');
                }
            case 'endDay':
                if(this.endDay.selection=="end_day"){
                    return this.$translate.instant('search-advanced.DateRange.label.DateRangeEnd') + ' ' + this.$translate.instant('nui.aria.advanced.dateEnd');
                }
                else{
                    return this.$translate.instant('search-advanced.DateRange.label.DateRangeEnd') + ' ' + this.$translate.instant('nui.aria.advanced.dateEnd') + ' ' + this.$translate.instant('nui.aria.advanced.dateDay');
                }
            case 'startMonth':
                if(this.startMonth.selection=="start_month"){
                    return this.$translate.instant('nui.aria.advanced.dateStart');
                }
                else{
                    return this.$translate.instant('nui.aria.advanced.dateStart') + ' ' + this.$translate.instant('nui.aria.advanced.dateMonth');
                }
            case 'endMonth':
                if(this.endMonth.selection=="end_month"){
                    return this.$translate.instant('nui.aria.advanced.dateEnd');
                }
                else{
                    return this.$translate.instant('nui.aria.advanced.dateEnd') + ' ' + this.$translate.instant('nui.aria.advanced.dateMonth');
                }
        }
    }
    private getAriaLabelForList(isStart: boolean, dayOrMonth: string, value: string) {
        if (isStart) {
            if (dayOrMonth == 'day') {
                if (value == 'start_day') {
                    return this.$translate.instant('nui.aria.advanced.dateStart') + ' ' + this.$translate.instant('nui.aria.advanced.dateDay');
                }
                else {
                    return this.$translate.instant('nui.aria.advanced.dateStart') + ' ' + this.$translate.instant('nui.aria.advanced.dateDay') + ' ' + value;
                }
            }
            else {
                if (value == 'start_month') {
                    return this.$translate.instant('nui.aria.advanced.dateStart') + ' ' + this.$translate.instant('nui.aria.advanced.dateMonth');
                }
                else {
                    return this.$translate.instant('nui.aria.advanced.dateStart') + ' ' + this.$translate.instant('nui.aria.advanced.dateMonth') + ' ' + value;
                }
            }
        }
        else {
            if (dayOrMonth == 'day') {
                if (value == 'end_day') {
                    return this.$translate.instant('nui.aria.advanced.dateEnd') + ' ' + this.$translate.instant('nui.aria.advanced.dateDay');
                }
                else {
                    return this.$translate.instant('nui.aria.advanced.dateEnd') + ' ' + this.$translate.instant('nui.aria.advanced.dateDay') + ' ' + value;
                }
            }
            else {
                if (value == 'end_month') {
                    return this.$translate.instant('nui.aria.advanced.dateEnd') + ' ' + this.$translate.instant('nui.aria.advanced.dateMonth');
                }
                else {
                    return this.$translate.instant('nui.aria.advanced.dateEnd') + ' ' + this.$translate.instant('nui.aria.advanced.dateMonth') + ' ' + value;
                }
            }
        }

    }

    public isBarcodeSearchEnabled(){
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VIEW_PROPERTIES,
            {source1: getVid(), source2: this.ENABLE_BARCODE_SEARCH, target: 'true'}).length > 0;
    }

    private setSelectedAdvancedSearchTab(searchTypeFromURL: string){           //chooses the tab to present when coming from deeplink
        let tabNum: number = this.sectionNameToTabIndex[searchTypeFromURL];
        if (searchTypeFromURL && tabNum && !this.isShowingFrbrList()){
            return tabNum;
        }
        return 0; //0 is the default 'Search Criteria' tab
    }

    private isShowingFrbrList(){
        let facetValue: string = this.$location.search().facet;
        if (facetValue && facetValue.startsWith("frbrgroupid")){
            return true;
        }
        return false;
    }

    public onTabSelect(tabName: string) {
        if (tabName==="searchCriteria" && this.$location.search().searchType){
            if (this.barcodeService.isBarcodeSearchPerformed()){   //indicates that we're moving between the tabs AFTER barcode search
                this.barcodeService.fromBarcodeSearchToSearchCriteria=true;
            }
            this.barcodeService.fromSearchCriteriaToBarcodeSearch=false;
            this.removeBarcodeParamsFromUrl();
            
        }
        else if (tabName==="barcodeSearch" && this.$location.search().searchType !== this.BARCODE_SEARCH_TAB){
            this.barcodeService.fromBarcodeSearchToSearchCriteria=false; 
            if (this.$location.search().searchType === undefined){ //no searchType value means we came from search Criteria
                this.barcodeService.fromSearchCriteriaToBarcodeSearch=true;
            this.addSearchTypeParamToUrl(this.BARCODE_SEARCH_TAB);    
            }     
        }
    }

    @preventStateReload
    private addSearchTypeParamToUrl(tabName: string) {
        this.$location.search('searchType', tabName);
    }

    @preventStateReload
    private removeBarcodeParamsFromUrl() {
        let searchParams= this.$location.search();
        searchParams.searchType=undefined;
        searchParams.barcode=undefined;
        this.$location.search(searchParams).replace();
    }

    public isBarcodeSearchTabSelected() {
        return this.$location.search().searchType === 'barcode';
     }

    private keyDownSupport(e) {
        if (e.keyCode === this.KEY_CODE.ENTER) {
            this.toggleFilters(false);
        }
    }
    
}

interface queryRow {
    boolOperator: string;
    searchOperator: string;
    searchCategory: string;
    searchQuery: string;
}

interface filter {
    label?: string;
    options?: string[];
    displayOptions?: string[];
    indexFields?: string[];
    indexField?: string;
    selection?: string;
    defaultOption?: string;
}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/advancedSearch.directive.ts